module.exports = require("open");